module.exports = __webpack_public_path__ + "img/wlw.5555e73.png";